import { TripCard } from '../components/TripCard';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/EmptyState';
import { Spinner } from '../components/ui/Spinner';
import { useAuth } from '../hooks/useAuth';
import { useTrips } from '../hooks/useTrips';
import { useT } from '../i18n';
import { logout } from '../lib/auth';

export function TripsListPage() {
  const { t } = useT();
  const { session } = useAuth();
  const { trips, loading, refreshing, error, refresh } = useTrips();

  return (
    <div className="flex flex-1 flex-col gap-4 px-4 py-5">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1 className="font-display text-xl font-semibold text-ink">{t('trips.listTitle')}</h1>
          {session ? <p className="text-sm text-ink-muted">{session.principal.nome}</p> : null}
        </div>
        <Button variant="ghost" onClick={() => void logout()} className="min-h-0 px-2 py-1 text-sm">
          {t('common.logout')}
        </Button>
      </div>

      {error ? <p className="text-sm text-danger">{error}</p> : null}

      {loading ? (
        <div className="flex flex-1 items-center justify-center">
          <Spinner className="h-6 w-6 text-accent" />
        </div>
      ) : trips.length === 0 ? (
        <EmptyState
          title={t('trips.empty.title')}
          description={t('trips.empty.description')}
          action={
            <Button variant="secondary" onClick={() => void refresh()} loading={refreshing}>
              {t('trips.refresh')}
            </Button>
          }
        />
      ) : (
        <div className="flex flex-col gap-3">
          {trips.map((trip) => (
            <TripCard key={trip.id} trip={trip} />
          ))}
        </div>
      )}
    </div>
  );
}
